import type { AssetTechnicalSaveBarProps } from "./asset-technical-save-bar.type";

import AppSaveBar from "@/modules/app-save-bar";
import "./asset-technical-save-bar.style.less";

const AssetTechnicalSaveBar = ({
  asset,
  onCancel,
  onSave,
  loading,
}: AssetTechnicalSaveBarProps) => {
  return (
    <div className="asset-technical-save-bar">
      <AppSaveBar
        date={asset?.updated_at}
        onSave={onSave}
        onCancel={onCancel}
        loading={loading}
      />
    </div>
  );
};

export default AssetTechnicalSaveBar;
